import { useMemo } from "react";

// Types
import { AggregationFunction } from "./types.ts";
import { MappingColumn } from "@/Common/types/meta/mappingFilters";

// Helpers
import { getAggregatedColumns, getPinnedColumns, makeGridColDefs, SEPARATOR_COL_ID } from "./helpers.tsx";

// Constants
const ID_COL = "_id";
const DEFAULT_COLUMN = { field: ID_COL };

export function useSmartTableColGenerator(mappingCols: MappingColumn[]) {
	const columns = useMemo(() => {
		const generatedCols = makeGridColDefs(mappingCols);
		return generatedCols.length ? generatedCols : [DEFAULT_COLUMN];
	}, [mappingCols]);

	const pinnedColumns = useMemo(() => {
		const cols = getPinnedColumns(mappingCols);
		return cols.length ? [...cols, SEPARATOR_COL_ID] : [];
	}, [mappingCols]);

	const initialEffectiveColumn = pinnedColumns?.[0] ?? columns?.[0]?.field ?? ID_COL;

	const aggregatedColumns = useMemo(() => {
		const aggregatedCols = getAggregatedColumns(mappingCols);
		aggregatedCols[initialEffectiveColumn] = AggregationFunction.size;

		return aggregatedCols;
	}, [mappingCols, initialEffectiveColumn]);

	return {
		columns,
		aggregatedColumns,
		pinnedColumns: {
			left: pinnedColumns,
		},
	};
}
